import { IntroStep } from '../core/services/tour.service';

export const comprehensionQuestionsIntroSteps: IntroStep[] = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#resources-title',
    intro: 'Comprehension Questions is where you can download the comprehension questions included in the Answer the Question tasks in the Online Student Program.'
  },
]
